export enum ComponentType {
    EMPTY = 0,
    PHOTO = 1,
    CONFIRM = 2,
    NUMBER = 3,
    AUDIO = 4,
    VIDEO = 5,
    DATE = 6,
    DRAW = 7,
    SELECT = 8,
    TEXT = 9,
    DURATION = 10,
    SCORE = 11,
    PROBLEM = 12,
    MATRIX = 13,
    GOTO = 14,
    SAMPLETEXT = 15,
    SAMPLEIMAGE = 16,
    SELECTAPI = 17,
    TREEVIEW = 18,
    GPS = 19,
    MODEL = 20,
    SAMPLEVIDEO = 21,
    SAMPLE = 22,
    CALCULATOR = 23,
    QRCODE = 24,
    IMAGERECOGNITION = 25,
    FILEUPLOAD = 26
}